import React from 'react';
import {
  HomeHero,
  HomeLogoStrip,
  HomeFeatureCarousel,
  HomePlatformWorks,
  HomePlatformAccordion,
  HomeDeviceCategories,
  HomeTestimonial,
  HomeClosingCta,
} from '../features/home';

export const Home: React.FC = () => {
  return (
    <div className="io-home">
      <HomeHero />
      <HomeLogoStrip />
      <HomeFeatureCarousel />
      <HomePlatformWorks />
      <HomePlatformAccordion />
      <HomeDeviceCategories />
      <HomeTestimonial />
      <HomeClosingCta />
    </div>
  );
};
